import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { modalAlert } from '../usePopup';

export const useBetslipNotEmptyPopup = (): { showPopup: Function } => {
  const { t } = useTranslation();
  const history = useHistory();

  const showPopup = (onConfirm: Function) => {
    modalAlert({
      title: t('account.betslipIsNotEmpty'),
      text: t('account.eventsInBetSlip'),
      successBtn: {
        text: t('account.replace'),
        onClick: onConfirm
      },
      cancelBtn: {
        text: t('account.cancel'),
        onClick: () => {
          const queryParams = new URLSearchParams(window.location.search);

          if (queryParams.has('booking_id')) {
            queryParams.delete('booking_id');
            history.replace({
              search: queryParams.toString()
            });
          }
        }
      },
      closable: false
    });
  };

  return {
    showPopup
  };
};
